import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { usePlatformStore } from "@/store/platform.store";
import { useWorkspaceStore } from "@/store/workspace.store";

function WorkspaceModeBanner() {
  const impersonation = useWorkspaceStore((s) => s.impersonation);
  const endCustomerPreview = useWorkspaceStore((s) => s.endCustomerPreview);
  const customer = usePlatformStore((s) =>
    impersonation ? s.getCustomer(impersonation.customerId) : undefined,
  );
  const navigate = useNavigate();

  if (!impersonation || !customer) return null;

  return (
    <Box sx={{ px: { xs: 1.25, sm: 2.5, md: 3.5 }, pt: 1 }}>
      <Alert
        severity="info"
        data-testid="customer-preview-banner"
        action={
          <Button
            color="inherit"
            size="small"
            data-testid="exit-customer-preview"
            onClick={() => {
              const path = endCustomerPreview();
              navigate(path);
            }}
          >
            Return to platform
          </Button>
        }
      >
        Platform operator · Viewing as <strong>{customer.name}</strong>{" "}
        (customer workspace)
      </Alert>
    </Box>
  );
}

export { WorkspaceModeBanner };
